jQuery('.woocommerce').on('click', '.quantity-up', function () {
    var min = jQuery(this).prev("input.qty").attr('min');
    var oldValue = parseFloat(jQuery(this).prev("input.qty").val());
    // console.log('click +1');
    // if (oldValue >= max) {
    //     console.log('max +1');
    //     var newVal = oldValue;
    // } else {
    //     var newVal = oldValue + 1;
    //     console.log('+1');
    // }
    var newVal = oldValue + 1;
    console.log(newVal);
    jQuery(this).prev("input.qty").val(newVal);
    jQuery(this).prev("input.qty").trigger("change");
});

jQuery('.woocommerce').on('click', '.quantity-down', function () {
    var min = jQuery(this).next("input.qty").attr('min');
    var oldValue = parseFloat(jQuery(this).next("input.qty").val());
    if (oldValue <= min) {
        var newVal = oldValue;
    } else {
        var newVal = oldValue - 1;
        console.log(newVal);
        // console.log('-1');
    }
    jQuery(this).next("input.qty").val(newVal);
    jQuery(this).next("input.qty").trigger("change");
});


var timeout;

function updateCart() {
    jQuery('.woocommerce').on('change', 'input.qty', function () {
        jQuery('.woocommerce-cart-form :input[name="update_cart"]').prop('disabled', false).attr('aria-disabled', false);
        if (timeout !== undefined) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(function () {
            jQuery("[name='update_cart']").trigger("click");
        }, 1000); // 1 second delay, half a second (500) seems comfortable too

    });
}

jQuery(function () {
    updateCart();
});

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
// ths > deactivate newsletter popup again
// window.onload = function () {
//     if (getCookie("newsletter_popup") != "") {
//     }
//     else {
//         $("#exampleModal").modal('show');
//         setCookie("newsletter_popup", "1", 3);
//     }
//
// };
